import { Stack } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { ConditionWithLabel } from "./condition-with-label"

export function RuleConditionsList({ conditions, combinator = "and", onUpdate, onCombinatorChange }) {
    return (
        <Stack spacing={1}>
            <Repeat
                list={conditions}
                item={
                    <ConditionWithLabel
                        conditions={conditions}
                        combinator={combinator}
                        onUpdate={onUpdate}
                        onCombinatorChange={onCombinatorChange}
                    />
                }
                keyFn={conditionKey}
            />
        </Stack>
    )
}

function conditionKey(condition, index) {
    return condition._id || index
}
